import { useState, useEffect } from "react";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  const getIsMobile = (size, height) => {
    try {
      let orientation = checkOrientation(size, height);
      if (orientation) {
        return true;
      }
      if (size) {
        if (size < 768) return true;
      }
      if (!size && window) {
        const mob = window.innerWidth < 768;
        return mob;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(getIsMobile(window.innerWidth, window.innerHeight));
    };
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  return isMobile;
};

const checkOrientation = (width, height) => {
  let type;
  if (window.screen.orientation) {
    const orientation = window.screen.orientation.type;
    if (orientation.includes("portrait")) {
      type = "portrait";
    } else if (orientation.includes("landscape")) {
      type = "landscape";
    }
  } else {
    // Fallback for older browsers
    if (window.matchMedia("(orientation: portrait)").matches) {
      type = "portrait";
    } else if (window.matchMedia("(orientation: landscape)").matches) {
      type = "landscape";
    }
  }
  if (width <= 1023 && height <= 472 && type == "landscape") {
    return true;
  }
};

export default useIsMobile;
